import moment, { Moment } from 'moment';
import React from 'react';
import ReactDatePicker from 'react-datepicker';


interface IProps {
    children?: React.ReactNode;
    defaultDate?: string;
    onChange?: (date: string) => void;
}

const DATE_FORMAT = 'YYYY-MM-DD';

const DatePicker: React.FC<IProps> = ({ defaultDate, onChange }) => {
    const handleDateChange = (date: Date | null) => {
        if (onChange && date) {
            onChange(moment(date).format(DATE_FORMAT));
        }
    };

    return (
        <div className="custom-datepicker-wrapper">
            <ReactDatePicker
                selected={defaultDate ? moment(defaultDate, DATE_FORMAT).toDate() : new Date()}
                onChange={handleDateChange}
                dateFormat="yyyy-MM-dd"
                className="input is-fullwidth"
                portalId="root"
                renderCustomHeader={({
                    date,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                }) => (
                    <div className="react-datepicker__custom-header">
                        <button
                            className="react-datepicker__custom-nav-btn"
                            onClick={decreaseMonth}
                            disabled={prevMonthButtonDisabled}
                            type="button"
                        >
                            <i className="fa fa-chevron-left" />
                        </button>
                        <div className="react-datepicker__current-month">
                            {moment(date).format('MMMM YYYY')}
                        </div>
                        <button
                            className="react-datepicker__custom-nav-btn"
                            onClick={increaseMonth}
                            disabled={nextMonthButtonDisabled}
                            type="button"
                        >
                            <i className="fa fa-chevron-right" />
                        </button>
                    </div>
                )}
            />
        </div>
    );
};

export default DatePicker;
